import { useEffect, useState, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";

const SUBLINES = [
  "Là où les émotions deviennent des arguments.",
  "Je transforme les malaises en connaissances.",
];

// Cinematic, once-per-session entrance. Sober & premium (Apple/Porsche feel).
export default function BrandIntro({ onDone }) {
  const [show, setShow] = useState(true);
  const subline = useMemo(() => SUBLINES[Math.floor(Math.random() * SUBLINES.length)], []);

  const finish = () => { setShow(false); };

  useEffect(() => {
    const t = setTimeout(finish, 2900);
    return () => clearTimeout(t);
  }, []);

  const ease = [0.22, 1, 0.36, 1];

  return (
    <AnimatePresence onExitComplete={onDone}>
      {show && (
        <motion.div
          data-testid="brand-intro"
          className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-[#050505] px-6"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.7, ease }}
          onClick={finish}
        >
          {/* subtle gold light bleed */}
          <div className="absolute w-[60vw] h-[60vw] max-w-[520px] max-h-[520px] rounded-full pointer-events-none"
            style={{ background: "radial-gradient(circle, rgba(212,175,55,0.12), transparent 60%)" }} />

          {/* Wordmark */}
          <motion.div className="relative font-display font-extrabold tracking-tight leading-none select-none"
            initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease }}>
            <span className="text-4xl md:text-6xl text-white">BIZA</span>
            <span className="text-4xl md:text-6xl gold-text">RRE</span>
            <span className="align-super ml-2 text-base md:text-xl text-gold tracking-[0.3em]">AI</span>
            <motion.div className="h-[2px] mt-2 gold-gradient rounded-full mx-auto"
              initial={{ width: 0 }} animate={{ width: "70%" }} transition={{ delay: 0.5, duration: 0.9, ease }} />
          </motion.div>

          {/* Signature */}
          <motion.p className="relative font-display text-xl md:text-3xl font-light mt-9 text-white/90"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.1, duration: 0.9, ease }}>
            Bienvenue dans le <span className="gold-text italic">bizarre.</span>
          </motion.p>
          <motion.p className="relative text-white/45 text-sm md:text-base mt-3 font-light text-center"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.7, duration: 0.9, ease }}>
            {subline}
          </motion.p>

          <motion.button onClick={finish} data-testid="brand-intro-skip"
            className="absolute bottom-8 text-white/30 hover:text-white/60 text-xs uppercase tracking-[0.2em] transition-colors"
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 2.2, duration: 0.6 }}>
            Entrer
          </motion.button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
